import React, {useEffect, useState} from 'react';
import { Modal, Button, Form, Row, Col, Card, Table, Badge, Dropdown, Pagination,  } from 'react-bootstrap';
import {useNavigate} from "react-router-dom";
import FormControl from "../../../shared/components/FormControl";
import {businessYearService} from "../../../services/businessYearService";
import eventEmitter from "../../../shared/eventEmitter";
import {EventEmitterTypes} from "../../../shared/eventEmitterEnum";
import notificationService from "../../../services/NotificationService";
import NotificationService from "../../../services/NotificationService";
import {listService} from "../../../services/listsService";

interface NewYearSetupProps {
    show: boolean;
    toggle: () => void;
    data: any;
}


const CopyOverJobsNewYearModal: React.FC<NewYearSetupProps> = ({show, toggle, data}) => {
    function handleSubmit() {
        if(data.canCopyJobsFromPreviousYear && !data.copyJobsFromPreviousYearInProgress) {
            businessYearService.copyJobsFromPreviousYear(data.year).then(r => {
                eventEmitter.emit(EventEmitterTypes.REFRESH_YEARLY_SETTINGS)
                toggle();
            });
        }
        else
            notificationService.error('Not allowed to copy jobs from previous year. It has already been done')
    }
    
    return (
        <Modal show={show} onHide={toggle}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-body text-center">
                        <span className="text-light icon mb-3">
                            <i className="fa-solid fa-square-question"></i>
                        </span>
                        {!data.copyJobsFromPreviousYearInProgress && (
                            <>
                                <p className="mb-4">
                                    Are you sure you want to setup the jobs for {data.year}? This will take a while. It will run in the background and this button will disappear when complete
                                </p>
                                <div className="mb-2">
                                    <button onClick={handleSubmit} type="button" className="btn btn-primary text-strong text-uppercase m-100">Yes,
                                        setup {data.year}
                                    </button>
                                </div>
                                <div className="pb-2">
                                    <a onClick={toggle} role="button" className="m-100 text-muted" data-bs-dismiss="modal">Nevermind</a>
                                </div>
                            </>
                        )}
                        {data.copyJobsFromPreviousYearInProgress && (
                            <>
                                <p className="mb-4">
                                    The update for {data.year} is already running. On a page reload, if the button is gone, the update is finished.
                                </p>
                                <div className="mb-2">
                                    <button onClick={toggle} type="button" className="btn btn-primary text-strong text-uppercase m-100">Okay</button>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default CopyOverJobsNewYearModal;
